export default {"src":"/_next/static/media/Analytics.cc54be6f.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};